<template>
    <!--问答留言-->
    <div class="details-box toast-box">
        <div class="details-title">
            <img src="../assets/kts/leavewords.png" alt="问答留言">
        </div>
        <div class="question">
            <div class="question-list">
                <div class="box" v-for="(item, index) in messageList" v-bind:key="index" v-if="messageList.length !== 0">
                    <img src="../assets/kts/personImg.png"/>
                    <div class="textBox">
                        <div class="top">
                            <p class="name">{{item.newMobile?item.newMobile:'手机尾号****'}}</p>
                            <p class="time">{{item.newTime}}</p>
                        </div>
                        <div class="text">
                            {{item.content}}
                        </div>
                    </div>
                </div>
                <!--暂无数据-->
                <div class="noData" v-if="messageList.length === 0">
                    <img src="../assets/kts/noData.png"/>
                    <p>暂无内容，快来留言吧</p>
                </div>
            </div>
            <div class="question-button">
                <div class="question-input">
                    <Emoji @click="selectedEmoji" class="emojiCss" />
                    <input type="text" v-model="content" v-on:input="change" ref="count" />
                    <p @click="sendMessage">发送</p>
                </div>
                <div v-show="error" class="error">请输入</div>
                <div class="question-desc">
                    您提出的宝贵问题有机会被选中在课程直播中由演讲嘉宾现场解答哦！本期现场交流提交问卷并被选中答问提问者, 将会获得精美礼品。
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import {getCookie} from "../utils/public";
    import bus from "../utils/eventBus";
    import { VueChatEmoji } from 'vue-chat-emoji'
    require("vue-chat-emoji/dist/vue-chat-emoji.css");

    export default {
        name: "Message",
        data() {
            return {
                isLogin: false,
                IsWap: false,
                messageList: [],
                page: 0,
                content: '',  //留言发送的内容
                name: getCookie('name'),
                error: false,  //留言发送的内容为空的错误提醒
                isDisable: true   //限制一秒内多次点击的事件
            };
        },
        props: ['id'],
        mounted(){
            if(this.screenWidth < 750){
                this.IsWap = true;
            }else {
                this.IsWap = false;
            }
        },
        computed:{
            loginStatus() {
                return this.$store.state.loginStatus;
            },
            type(){
                return this.$store.state.type;
            },
            userInfo() {
                return this.$store.state.info;
            },
        },
        watch: {
            loginStatus: function (val, oVal) {
                let self = this;
                if(val == 1){
                    setTimeout(function() {
                        self.isLogin = true;
                        self.name = self.$store.state.info.firstName + self.$store.state.info.lastName
                    }, 1000)
                }else {
                    self.isLogin = false
                }

            },
            screenWidth: function (val, oVal) {
                if(val < 750){
                    this.IsWap = true;
                }else {
                    this.IsWap = false;
                }
            },
            type(val){
                this.messageList= [];
                this.getList()
            },
            id(val){
                this.messageList= [];
                this.content = '';
                this.error = false;
                this.getList()
            },
            content:{
                handler:function(){
                    let _sum = 60; //字体限制为60个
                    this.$refs.count.setAttribute("maxlength",_sum);
                },
                deep:true
            }
        },
        components: {
            Emoji: VueChatEmoji
        },
        created() {
          this.getList()
        },
        methods:{
            //获取留言列表
            getList(){
                let _this = this;
                if(_this.id){
                    let param = {
                        'tenantId': smarket.Config('tenantId'),
                        'topicId': _this.id,
                        'status': 1,  //帖子状态 (0：未审核，1：已审核，2-全部)
                        'isHaveReply': 0, //是否包含回帖(1：是;0：否)
                        'openId': '',
                        'globalUserId': '',
                        'sess': '',
                        'start': _this.page,
                        'num': 50
                    }
                    $.ajax({ //获取留言列表 接口
                        url: window.config.api.gateway.general + '/api/topic/message/query',
                        type: 'post',
                        dataType: 'json',
                        data: param
                    }).then(function (data) {
                        if(data.body.content.items.length != 0){
                            data.body.content.items.forEach(item =>{
                                if(item.createTime &&　moment.unix(item.createTime).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')){
                                    item.newTime = moment.unix(item.createTime).format('HH:mm:ss');
                                }else if(item.createTime){
                                    item.newTime = moment.unix(item.createTime).format('YYYY-MM-DD');
                                }
                                if(item.mobile){
                                    item.newMobile = '手机尾号' + item.mobile.substring(item.mobile.length-4,item.mobile.length);
                                }
                            });
                            _this.messageList = _this.messageList.concat(data.body.content.items);
                            if(data.body.content.total > (_this.page + 1) * 50){
                                _this.page = _this.page + 1;
                                this.getList();
                            }
                        }else{
                            _this.messageList = data.body.content.items || [];
                        }
                    });
                }
            },
            //留言板——发送消息
            sendMessage(){
                if(this.isDisable){
                    if(!this.loginStatus){
                        bus.$emit('showToast', '想要留言，请先“注册”或“登录”');
                        return;
                    }
                    if(this.content === ''){
                        this.error = true;
                        return;
                    }
                    let param = {
                        'tenantId': smarket.Config('tenantId'),
                        'topicId': this.id,
                        'content': this.content,
                        'postId':0, //主帖ID【回帖时此ID为回复帖ID，发主帖时此值为0】
                        'enableReply': 0,
                        'sess': getCookie('sess'),
                        'nickname': this.name,
                        'isAnonymous':0,
                    };
                    $.ajax({
                        url: window.config.api.gateway.general + '/api/topic/message/create',
                        type: 'post',
                        dataType: 'json',
                        data: param
                    }).then( data =>{
                        this.messageList.unshift({
                            content: this.content,
                            newTime: moment().format('HH:mm:ss'),
                            createrPic: "",
                            nickname: this.name,
                            newMobile: '手机尾号' + this.userInfo.mobile.substring(this.userInfo.mobile.length-4,this.userInfo.mobile.length) || this.userInfo.InternationalMobile.substring(this.userInfo.InternationalMobile.length-4,this.userInfo.InternationalMobile.length)
                        });
                        this.content = '';
                    })
                }
                this.isDisable = false
                setTimeout(() =>{
                    this.isDisable = true;
                },1000)
            },
            change(){
                if(this.content !== '') this.error = false;
            },
            selectedEmoji(args) {
                this.content = this.content + args.emoji;
            }
        }
    }
</script>

<style lang="scss" scoped >
    /*问答留言*/
    .details-box{
        .details-title {
            width: 100px;
            overflow: hidden;
            padding: 2px 0;

            &.Overview {
                width: 60px;
            }

            img {
                height: 19px;
                display: block;
            }
        }
        .toast-box {
            margin-top: 35px;
        }
        .question{
            .question-list{
                height: 280px;
                margin: 15px 0;
                overflow-y: auto;
                position: relative;
                .box{
                    margin-top: 20px;
                    img{
                        float: left;
                        width: 35px;
                        height: 35px;
                        display: block;
                        margin-right: 10px;
                        margin-top: 10px;
                    }
                    .textBox{
                        width: 425px;
                        float: left;
                        .top{
                            .name,.time{
                                color: #a4a1a9;
                                font-size: 13px;
                                display: inline-block;
                                padding: 5px;
                                margin: 0;
                            }
                            .time{
                                float: right;
                            }
                        }
                        .text{
                            background: #fff;
                            color: #524f56;
                            font-size: 15px;
                            padding: 15px;
                            word-break: break-all;
                        }
                    }
                }
                .box:after{
                    content: "";
                    display: block;
                    height: 0;
                    clear:both;
                    visibility: hidden;
                }
                .noData{
                    width: 200px;
                    height: 140px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    img{
                        width: 96px;
                        height: 81px;
                        display: block;
                        margin: 0 auto;
                    }
                    p{
                        color: #a4a1a9;
                        font-size: 15px;
                        text-align: center;
                    }
                }
            }
            .question-button{
                width: 100%;
                line-height: 45px;
                .question-input{
                    font-size: 15px;
                    position: relative;
                    .emojiCss{
                        position: absolute;
                        top: 68px;
                        left: 15px;
                    }

                    input{
                        width: 85%;
                        height: 45px;
                        line-height: 45px;
                        background: #ededed;
                        color: #000;
                        display: inline-block;
                        padding: 0 3% 0 50px;
                        border: 0;
                        border-radius: 5px 0 0 5px;
                        outline:none;
                    }
                    input:focus{
                        outline:none;
                    }
                    p{
                        width: 15%;
                        display: inline-block;
                        background: #e90029;
                        color: #fff;
                        text-align: center;
                        border-radius: 0 5px 5px 0;
                        cursor: pointer;
                        margin: 10px 0 5px 0;
                    }
                }
                .error{
                    background: url("../assets/kts/tixing.png") no-repeat left center;
                    background-size: 15px;
                    padding-left: 18px;
                    color: #e90029;
                    font-size: 13px;
                    height: 20px;
                    line-height: 20px;
                }
                .question-desc{
                    margin-top: 10px;
                    color: #999999;
                    font-size: 13px;
                    line-height: 20px;
                }
            }
        }
    }

    /* web */
    @media screen and (max-width: 750px) {
        .details-box{
            .details-title {
                width: 100%;
                overflow: hidden;
                padding: pxToRem(4) 0;

                &.Overview {
                    width: 100%;
                }

                img {
                    height: pxToRem(28);
                    display: block;
                }
            }
            .question{
                .question-list{
                    height: pxToRem(440);
                    margin: pxToRem(25) 0;
                    overflow-y: auto;
                    position: relative;
                    .box{
                        margin-top: pxToRem(15);
                        img{
                            float: left;
                            width: pxToRem(45);
                            height: pxToRem(45);
                            display: block;
                            margin-right: pxToRem(5);
                            margin-top: pxToRem(15);
                        }
                        .textBox{
                            width: pxToRem(560);
                            .top{
                                .name,.time{
                                    font-size: pxToRem(20);
                                    padding: pxToRem(5);
                                }
                            }
                            .text{
                                font-size: pxToRem(24);
                                padding: pxToRem(20);
                            }
                        }
                    }
                    .box:after{
                        content: "";
                        display: block;
                        height: 0;
                        clear:both;
                        visibility: hidden;
                    }
                    .noData{
                        width: 200px;
                        height: 140px;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        img{
                            width: 96px;
                            height: 81px;
                            display: block;
                            margin: 0 auto;
                        }
                        p{
                            color: #a4a1a9;
                            font-size: 15px;
                            text-align: center;
                        }
                    }
                }
                .question-button{
                    width: 100%;
                    line-height: pxToRem(55);
                    .question-input{
                        font-size: pxToRem(26);
                        input{
                            width: 80%;
                            height: pxToRem(55);
                            line-height: pxToRem(55);
                            background: #ededed;
                            color: #000;
                            display: inline-block;
                            padding: 0 3% 0 pxToRem(100);
                            border: 0;
                            border-radius: 5px 0 0 5px;
                            outline:none;
                        }
                        input:focus{
                            outline:none;
                        }
                        .emojiCss{
                            top: pxToRem(66)
                        }
                        p{
                            width: 20%;
                            display: inline-block;
                            background: #e90029;
                            color: #fff;
                            text-align: center;
                            border-radius: 0 5px 5px 0;
                            cursor: pointer;
                            margin: 10px 0 5px 0;
                        }
                    }
                    .error{
                        background: url("../assets/kts/tixing.png") no-repeat left center;
                        background-size: pxToRem(24);
                        padding-left: 18px;
                        color: #e90029;
                        font-size: pxToRem(24);
                        height: pxToRem(36);
                        line-height: pxToRem(40);
                    }
                    .question-desc{
                        margin-top: 10px;
                        color: #999999;
                        font-size: 13px;
                        line-height: 20px;
                    }
                }
            }
        }
    }
</style>
<style lang="scss" >
    .composer-popover.active{
        width: 500px!important;
        position: absolute!important;
        top: 0!important;
        left: -20px!important;
        height: 202px;
    }
    .emoji-category-group{
        bottom: 0!important;
    }
    /* web */
    @media screen and (max-width: 750px){
        .composer-popover.active{
            width: pxToRem(650)!important;
            position: absolute!important;
            top: pxToRem(-660)!important;
            left: -20px!important;
            height: pxToRem(580);
        }
        .composer-popover-body{
            top: pxToRem(80)!important;
        }
        .icon-emoticon{
            font-size: pxToRem(36)!important;
        }
        .composer-popover[data-v-03349ba9] {
            -webkit-transition-duration: 0s;
            transition-duration: 0s;
            -webkit-transition-delay: 0ms;
            transition-delay: 0ms;
            -webkit-transform-style: flat;
            transform-style: flat;
            -webkit-transform-origin: 50% 50% 0;
            transform-origin: 50% 50% 0;
            -webkit-transition: all 0s linear;
            transition: all 0s linear;
        }
        span.send-button{
            padding: 0!important;
            height: pxToRem(40)!important;
        }
    }
</style>